import { Injectable } from '@angular/core';
import {RoughAnnotation} from "rough-notation/lib/model";

@Injectable({
  providedIn: 'root'
})
export class RoughHeadlineService {

  private _headlines: RoughAnnotation[] = [];
  constructor() { }

  addHeadline(roughAnnotation: RoughAnnotation) {
    this._headlines.push(roughAnnotation);
  }

  updateHeadlines() {
    window.requestAnimationFrame(() => {
      this._headlines.forEach((el) => {
       if(el.isShowing()) {
         el.show();
       }
      });
    });
  }
}
